import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Components
import { TableWrapper } from './AiDocumentDetails.elements'

// Views
import { Container } from 'views/components'
import { AiDocumentSummary } from 'views/containers'
import { App, Header, PageWrapper, Sidebar, Content } from 'views/layouts'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function AiDocumentDetails() {
  const [userCredentials] = useLocalStorage('userCredentials', {})

  useEffect(() => {
    if (userCredentials?.role_id !== 0 || !userCredentials) {
      window.location.replace(window.location.origin)
    }
  }, [userCredentials])
  return (
    <App>
      <Sidebar />
      <Header link="/admin/ai/documents" pageTitle="AI Document Details" />
      <Content>
        <PageWrapper>
          <Container>
            <TableWrapper>
              <AiDocumentSummary />
            </TableWrapper>
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
AiDocumentDetails.defaultProps = {
  actions: {},
  ui: {},
  filters: {},
}

// Proptypes Validation
AiDocumentDetails.propTypes = {
  actions: PropTypes.shape({
    setActiveModule: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
  ui: PropTypes.shape({}),
  filters: PropTypes.shape({}),
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentDetails)
